// src/main.jsx
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './index.css';
import useGlobale from './components/global';
import App from './App';
import LoginPage from './pages/LoginPage';
import SettingPage from './pages/SettingsPage';
import DashboardPage from './pages/DashboardPage';
import ListeFilierePage from './pages/ListeFilierePage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EtablissementPage from './pages/EtablissementPage';
import AnneeAcademiquePage from './pages/AnneeAcademiquePage';
import SallePage from './pages/SallePage';
import FraisInscriptionPage from './pages/FraisInscriptionPage';
import ListeNiveauPage from './pages/ListeNiveauPage';
import ListeSemestrePage from './pages/ListeSemestrePage';
import ModalitePaiementPage from './pages/ModalitePaiementPage';
import TarificationPage from './pages/TarificationPage';
import ModulePage from './pages/ModulePage';
import UniteEnseignementPage from './pages/UniteEnseignementPage';
import ClassePage from './pages/ClassePage';
import DetailClasse from './pages/DetailClasse';
import EnseignantPage from './pages/EnseignantPage';
import DepartementPage from './pages/DepartementPage';
import PersonnelPage from './pages/PersonnelPage';
import InscriptionPage from './pages/InscriptionPage';
import CreateInscriptionPage from './pages/CreateInscriptionPage';
import EtudiantPage from './pages/EtudiantPage';
import DetailsEtudiant from './pages/DetailsEtudiant';
import ParentPage from './pages/ParentPage';
import DetailsParentPage from './pages/DetailsParentPage';
import DetailsInscriptionPage from './pages/DetailsInscription';
import ListeEmploisPage from './pages/ListeEmploisPage';
import CreateEmploisPage from './pages/CreateEmploisPage';
import DetailEmplois from './pages/DetailEmplois';
import EditEmplois from './pages/EditEmplois';
import AssiduitePage from './pages/AssiduitePage';
import PonctualitePage from './pages/PonctualitePage';
import EvaluationPage from './pages/EvaluationPage';
import CreateNoteEvaluationPage from './pages/CreateNoteEvaluationPage';
import ListeNotePage from './pages/ListeNotePage';
import ListeExamenPage from './pages/ListeExamenPage';
import CreateExamenPage from './pages/CreateExamenPage';
import DetailsExamenPage from './pages/DetailsExamenPage';
import EditExamenPage from './pages/EditExamenPage';
import CreateNoteExamenPage from './pages/CreateNoteExamenPage';
import ListeNoteExamenPage from './pages/ListeNoteExamenPage';
import FinancePage from './pages/FinancePage';
import SoutenancePage from './pages/SoutenancePage';
import DetailsProceVerbal from './pages/DetailsProceVerbal';
import ConcoursPage from './pages/ConcoursPage';
import CreateNoteConcour from './pages/CreateNoteConcour';
import BulletinNotePage from './pages/BulletinNotePage';
import CreateBulletin from './pages/CreateBulletin';
import BulletinViewPage from './pages/BulletinViewPage';
import UtilisateurPage from './pages/UtilisateurPage';
import CreateRolePage from './pages/CreateRolePage';
import NotFoundPage from './pages/NotFoundPage';
import PageTransition from './components/PageTransition';
import AuthModal from './components/AuthModal';
import AllBulletinPage from './pages/AllBulletinPage';

// Composant pour scroll automatique vers le haut
const ScrollToTop = () => {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return null;
};

// Composant pour vérifier l'authentification au démarrage
const AuthChecker = () => {
  const checkAuth = useGlobale(state => state.checkAuth);
  
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);
  
  return null;
};

const PrivateRoute = ({ element: Component }) => {
  const isAuthenticated = useGlobale(state => state.isAuthenticated);
  const location = useLocation();

  // Utiliser la nouvelle fonction isAuthenticated qui tient compte du modal
  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return Component;
};

const AppRouter = () => {
  // Sélectionner l'état du modal d'authentification
  const authModal = useGlobale(state => state.authModal);
  const hideAuthModal = useGlobale(state => state.hideAuthModal);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthChecker />
      <PageTransition>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      
      {/* Modal d'authentification global */}
      <AuthModal
        isOpen={authModal.isOpen}
        onClose={hideAuthModal}
        message={authModal.message}
        onSuccess={authModal.onSuccess}
      />
      
      <Routes>
        {/* Routes publiques */}
        <Route path="/login" element={<LoginPage />} />
       

        {/* Routes protégées */}
        <Route path="/" element={<PrivateRoute element={<DashboardPage />} />} />
        <Route path="/settings" element={<PrivateRoute element={<SettingPage />} />} />
        <Route path="/dashboard" element={<PrivateRoute element={<DashboardPage />} />} />
        <Route path="/liste-filieres" element={<PrivateRoute element={<ListeFilierePage />} />} />
        <Route path="/etablissement" element={<PrivateRoute element={<EtablissementPage />} />} />
        <Route path="/annee-academique" element={<PrivateRoute element={<AnneeAcademiquePage />} />} />
        <Route path="/frais-inscription" element={<PrivateRoute element={<FraisInscriptionPage />} />} />
        <Route path="/salle" element={<PrivateRoute element={<SallePage />} />} />
        <Route path="/liste-niveaux" element={<PrivateRoute element={<ListeNiveauPage />} />} />
        <Route path="/liste-semestres" element={<PrivateRoute element={<ListeSemestrePage />} />} />
        <Route path="/modalites-paiement" element={<PrivateRoute element={<ModalitePaiementPage />} />} />
        <Route path="/tarification" element={<PrivateRoute element={<TarificationPage />} />} />
        <Route path="/modules" element={<PrivateRoute element={<ModulePage />} />} />
        <Route path="/unite-enseignement" element={<PrivateRoute element={<UniteEnseignementPage />} />} />
        <Route path="/classes" element={<PrivateRoute element={<ClassePage />} />} />
        <Route path="/detail-classe/:classeId" element={<PrivateRoute element={<DetailClasse />} />} />
        <Route path="/enseignants" element={<PrivateRoute element={<EnseignantPage />} />} />
        <Route path="/departements" element={<PrivateRoute element={<DepartementPage />} />} />
        <Route path="/personnels" element={<PrivateRoute element={<PersonnelPage />} />} />
        <Route path="/inscriptions" element={<PrivateRoute element={<InscriptionPage />} />} />
        <Route path="/create-inscription" element={<PrivateRoute element={<CreateInscriptionPage />} />} />
        <Route path="/etudiants" element={<PrivateRoute element={<EtudiantPage />} />} />
        <Route path="/etudiant/:id" element={<PrivateRoute element={<DetailsEtudiant />} />} />
        <Route path="/parents" element={<PrivateRoute element={<ParentPage />} />} />
        <Route path="/parent/:id" element={<PrivateRoute element={<DetailsParentPage />} />} />
        <Route path="/details-inscription/:id" element={<PrivateRoute element={<DetailsInscriptionPage />} />} />
        <Route path="/liste-emplois" element={<PrivateRoute element={<ListeEmploisPage />} />} />
        <Route path="/create-emploi" element={<PrivateRoute element={<CreateEmploisPage />} />} />
        <Route path="/details-emploi/:id" element={<PrivateRoute element={<DetailEmplois />} />} />
        <Route path="/edit-emploi/:id" element={<PrivateRoute element={<EditEmplois />} />} />
        <Route path="/assiduite" element={<PrivateRoute element={<AssiduitePage />} />} />
        <Route path="/ponctualite" element={<PrivateRoute element={<PonctualitePage />} />} />
        <Route path="/evaluations" element={<PrivateRoute element={<EvaluationPage />} />} />
        <Route path="/evaluations/notes/:controleId" element={<PrivateRoute element={<CreateNoteEvaluationPage />} />} />
        <Route path="/evaluations/liste-notes/:controleId" element={<PrivateRoute element={<ListeNotePage />} />} />
        <Route path="/examens" element={<PrivateRoute element={<ListeExamenPage />} />} />
        <Route path="/finance" element={<PrivateRoute element={<FinancePage />} />} />
        <Route path="/examens/create" element={<PrivateRoute element={<CreateExamenPage />} />} />
        <Route path="/examens/:id" element={<PrivateRoute element={<DetailsExamenPage />} />} />
        <Route path="/examens/:id/edit" element={<PrivateRoute element={<EditExamenPage />} />} />
        <Route path="/examens/sessions/:sessionId/notes" element={<PrivateRoute element={<CreateNoteExamenPage />} />} />
        <Route path="/examens/sessions/:sessionId/liste-notes" element={<PrivateRoute element={<ListeNoteExamenPage />} />} />
        <Route path="/soutenance" element={<PrivateRoute element={<SoutenancePage key="soutenance-page" />} />} />
        <Route path="/proces-verbal/:id" element={<PrivateRoute element={<DetailsProceVerbal />} />} />
        <Route path="/concours" element={<PrivateRoute element={<ConcoursPage />} />} />
        <Route path="/concours/epreuves/:epreuveId/notes" element={<PrivateRoute element={<CreateNoteConcour />} />} />
                    <Route path="/bulletins-notes" element={<PrivateRoute element={<BulletinNotePage />} />} />
            <Route path="/create-bulletin" element={<PrivateRoute element={<CreateBulletin />} />} />
            <Route path="/bulletin/:bulletinId" element={<PrivateRoute element={<BulletinViewPage />} />} />
            <Route path="/bulletins-classe" element={<PrivateRoute element={<AllBulletinPage />} />} />
        <Route path="/utilisateurs" element={<PrivateRoute element={<UtilisateurPage />} />} />
        <Route path="/roles/create" element={<PrivateRoute element={<CreateRolePage />} />} />
        <Route path="/roles/:roleId/edit" element={<PrivateRoute element={<CreateRolePage />} />} />
          
          {/* Route 404 - Doit être en dernier */}
          <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </PageTransition>
    </BrowserRouter>
  );
};

// Suppression de React.StrictMode pour éviter les appels API doubles en développement
ReactDOM.createRoot(document.getElementById('root')).render(
  <AppRouter />
);